// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, Input, OnInit } from '@angular/core';
import { Role } from '@app/core';
import { Store } from '@ngrx/store';
import { State } from '@app/access-management/state';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RolesEffects } from '@app/access-management/state/roles.effects';

@Component({
  selector: 'app-group-details-roles-tab',
  templateUrl: './group-details-roles-tab.component.html',
  styleUrls: ['./group-details-roles-tab.component.scss']
})
export class GroupDetailsRolesTabComponent implements OnInit {
  readonly columns = [
    {
      name: 'Name',
      prop: 'name',
      cellClass: 'ml-8 text-info',
      headerClass: 'ml-8',
      flexGrow: 1
    },
    { name: 'Description',
      prop: 'description',
      flexGrow: 2 }
  ];

  @Input() roles: Role[] | undefined = undefined;
  constructor(private modalService: NgbModal, private store: Store<State>) {}

  ngOnInit() {}

  onRemoveRow(index: number) {
    // if (this.policies !== undefined) {
    //   const modalRef = this.modalService.open(DeleteModalComponent, { centered: true, windowClass: 'no-border' });
    //   modalRef.componentInstance.removeItem = {type: RemoveType.POLICY, data: this.policies[index]} as RemoveItem;
    //   // Wait for a result from the modal. Note, this method can't use async await, because it causes funny behavior
    //   // when called from an angular template
    //   const resultPromise = modalRef.result as Promise<RemoveResult>;
    //   resultPromise.then(result => {
    //     switch (result) {
    //       case RemoveResult.REMOVE_SUCCEEDED: {
    //         // Todo: should call update data by calling GET api
    //         // But here just remove the item from []users at FE
    //         if (this.policies !== undefined) {
    //           this.policies.splice(index, 1);
    //           this.policies = [...this.policies];
    //         }
    //         // Show global indicator info window
    //         this.store.dispatch(
    //           new QueueAlertAction({ alertText: `Role delete succeeded.`, alertType: AlertType.SUCCESS })
    //         );
    //         break;
    //       }

    //       case RemoveResult.REMOVE_FAILED: {
    //         this.store.dispatch(
    //           new QueueAlertAction({ alertText: `Role delete failed.`, alertType: AlertType.ERROR })
    //         );
    //         break;
    //       }

    //       default: {
    //         break;
    //       }
    //     }
    //   });
    // }
  }

  trackColumns(idx: number) {
    return idx;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/groups/group-details/group-details-roles-tab/group-details-roles-tab.component.ts